import { useEffect, useState } from 'react';
import { getLeaderboard } from '../../api';
import type { LeaderboardEntry } from '../../types';
import { useAuthStore } from '../../store/authStore';
import './Leaderboard.css';

export function Leaderboard() {
  const [entries, setEntries] = useState<LeaderboardEntry[]>([]);
  const [myRank, setMyRank] = useState(0);
  const [period, setPeriod] = useState<'alltime' | 'week' | 'today'>('alltime');
  const [isLoading, setIsLoading] = useState(false);
  const user = useAuthStore(s => s.user);

  useEffect(() => {
    setIsLoading(true);
    getLeaderboard(period)
      .then((data) => {
        setEntries(data.entries);
        setMyRank(data.my_rank);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, [period]);

  return (
    <div className="leaderboard">
      <h2>Leaderboard</h2>

      <div className="period-tabs">
        {(['today', 'week', 'alltime'] as const).map(p => (
          <button
            key={p}
            className={`period-tab ${period === p ? 'active' : ''}`}
            onClick={() => setPeriod(p)}
          >
            {p === 'today' ? 'Today' : p === 'week' ? 'This Week' : 'All Time'}
          </button>
        ))}
      </div>

      {myRank > 0 && (
        <div className="my-rank">Your rank: <strong>#{myRank}</strong></div>
      )}

      {isLoading ? (
        <div className="leaderboard-loading">Loading...</div>
      ) : entries.length === 0 ? (
        <div className="leaderboard-empty">No data yet. Start solving!</div>
      ) : (
        <div className="leaderboard-list">
          {entries.map((entry) => {
            const isMe = user && (entry.username === user.username || entry.first_name === user.first_name);
            return (
              <div key={entry.rank} className={`leaderboard-row ${isMe ? 'me' : ''}`}>
                <span className="lb-rank">#{entry.rank}</span>
                <span className="lb-name">{entry.username || entry.first_name}</span>
                <span className="lb-solved">{entry.solved} solved</span>
                {entry.streak > 0 && <span className="lb-streak">{entry.streak}d streak</span>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
